/**
 * KD Presse logo - black text on transparent background.
 * Use `invert` prop on dark backgrounds (e.g. login side panel).
 */
export default function Logo({ className = "h-8", invert = false, alt = "KD Presse", testid = "kd-logo" }) {
  return (
    <img
      src="/logo-sidebar.png"
      alt={alt}
      data-testid={testid}
      className={`${className} w-auto select-none ${invert ? "invert brightness-0" : ""}`}
      draggable={false}
    />
  );
}
